const RoadmapIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="roadmap">
        <g id="Group">
          <path
            id="Vector"
            d="M6.10234 14.6431H6.0625V12.9224C6.74441 12.6806 7.23437 12.0295 7.23437 11.2654C7.23437 10.2963 6.4457 9.50758 5.47656 9.50758C4.50742 9.50758 3.71875 10.2963 3.71875 11.2654C3.71875 12.0295 4.20871 12.6806 4.89062 12.9224V14.6431H2.58594C2.2625 14.6431 2 14.9056 2 15.2291V19.9166C2 20.2404 2.2625 20.5025 2.58594 20.5025H6.08633L8.67968 17.5912L6.10234 14.6431Z"
            fill="white"
            fillOpacity="0.5"
          />
          <path
            id="Vector_2"
            d="M12.3934 14.6431H11.8047V10.1881C12.4866 9.94621 12.9766 9.29508 12.9766 8.53102C12.9766 7.56188 12.1879 6.77321 11.2188 6.77321C10.2497 6.77321 9.46099 7.56188 9.46099 8.53102C9.46099 9.29508 9.95095 9.94621 10.6329 10.1881V14.6431H7.65864L9.902 17.2091C10.0965 17.4314 10.095 17.7638 9.89849 17.9845L7.65552 20.5025H12.377L14.9704 17.5912L12.3934 14.6431Z"
            fill="white"
            fillOpacity="0.5"
          />
          <path
            id="Vector_3"
            d="M21.8515 17.1611L19.7836 14.8396C19.6726 14.7146 19.5133 14.6431 19.3461 14.6431H16.6402V9.01734H21.414C21.8878 9.03277 22.1794 8.43363 21.8754 8.07047L20.4828 6.29039L21.8816 4.43649C22.1764 4.07133 21.8828 3.48262 21.414 3.49782H16.0542C15.7304 3.49782 15.4683 3.75993 15.4683 4.08375V14.6431H13.9496L16.1929 17.2091C16.3871 17.4314 16.3855 17.7638 16.189 17.9845L13.946 20.5025H19.346C19.5152 20.5025 19.6757 20.4294 19.7871 20.3021L21.855 17.9365C22.0496 17.7142 22.048 17.3818 21.8515 17.1611Z"
            fill="white"
            fillOpacity="0.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default RoadmapIcon;
